import { createEntityReducer } from 'ext/lib/collections';
import { TYPE } from './actions';
import type { UserPropertiesState } from './types';

export default createEntityReducer(TYPE);

export const selectUserProperties = <
  T extends { userProperties: UserPropertiesState }
>(
  state: T
): UserPropertiesState => state.userProperties;
